import { put, fork, takeEvery } from 'redux-saga/effects'
import { takeLatestAndCancel } from './take'
import makePaginatedListSaga from './paginated'
import { authApiCall } from './helpers'

import {
  GET_MESSAGES,
  GET_MESSAGE,
  GET_MESSAGE_LOADING,
  GET_MESSAGE_FAILURE,
  GET_MESSAGE_SUCCESS,
  MARK_MESSAGE_AS_READ,
  MARK_MESSAGE_AS_READ_LOADING,
  MARK_MESSAGE_AS_READ_FAILURE,
  MARK_MESSAGE_AS_READ_SUCCESS,
} from '../actions'

import * as api from '../api'

function* handleGetMessage({ payload }) {
  const messageId = payload
  yield put({ type: GET_MESSAGE_LOADING })
  try {
    const message = yield authApiCall(api.getMessage, messageId)
    yield put({ type: GET_MESSAGE_SUCCESS, payload: message })
  } catch (error) {
    yield put({ type: GET_MESSAGE_FAILURE, error })
  }
}

function* handleMarkMessageAsRead({ payload }) {
  const messageId = payload
  yield put({ type: MARK_MESSAGE_AS_READ_LOADING })
  try {
    yield authApiCall(api.markMessageAsRead, messageId)
    yield put({ type: MARK_MESSAGE_AS_READ_SUCCESS, payload: messageId })
  } catch (error) {
    yield put({ type: MARK_MESSAGE_AS_READ_FAILURE, error })
  }
}

// Saga of messages
export default function* messages() {
  yield fork(
    makePaginatedListSaga(
      GET_MESSAGES,
      api.getMessages,
      state => state.messages
    )
  )
  yield fork(takeLatestAndCancel, GET_MESSAGE, GET_MESSAGES, handleGetMessage)
  yield takeEvery(MARK_MESSAGE_AS_READ, handleMarkMessageAsRead)
}



// WEBPACK FOOTER //
// ./src/saga/messages.js